'use client';

import { FC } from 'react';
import { Pill, Text, Tooltip } from '@/_components';
import { K1PackageStatusCellProps } from './K1PackageStatusCell.types';
import styles from './K1PackageStatusCell.module.css';
import { useRouter } from 'next/navigation';

export const K1PackageStatusCell: FC<K1PackageStatusCellProps> = ({
  taxReturn,
}) => {
  const { push } = useRouter();

  const getStatusInfo = () => {
    switch (taxReturn.k1_distribution_status) {
      case 'not_applicable':
        return {
          label: 'N/A',
          intent: 'secondary' as const,
          tooltip:
            'K-1 packages are not applicable for this entity type or the tax return is not sent.',
        };
      case 'no_k1_packages':
        return {
          label: 'None',
          intent: 'secondary' as const,
          tooltip: 'No K-1 packages have been uploaded for this tax return.',
        };
      case 'sent_to_partner':
        return {
          label: 'All sent',
          intent: 'success' as const,
          tooltip: 'All K-1 packages have been sent to partners.',
        };
      case 'not_sent_to_partner':
        return {
          label: 'Not sent',
          intent: 'warning' as const,
          tooltip: 'K-1 packages have not been sent to partners yet.',
        };
      case 'partially_sent_to_partner':
        return {
          label: 'Partially sent',
          intent: 'warning' as const,
          tooltip: 'Some K-1 packages have been sent to partners, but not all.',
        };
      default:
        return {
          label: 'Unknown',
          intent: 'secondary' as const,
          tooltip: 'K-1 package status is unknown.',
        };
    }
  };

  const handleClick = () => {
    if (taxReturn.k1_distribution_status === 'not_applicable') {
      return;
    }

    // Navigate to K1 distribution page
    push(
      `/admin/${taxReturn.company_hash}/tax-returns/${taxReturn.id}/k1-distribution`,
    );
  };

  const statusInfo = getStatusInfo();

  return (
    <Tooltip>
      <Tooltip.Content>
        <Text type="tiny" color="currentcolor">
          {statusInfo.tooltip}
        </Text>
      </Tooltip.Content>
      <Tooltip.Trigger>
        <div
          className={styles.k1PackageStatusCell}
          onClick={handleClick}
          style={{
            cursor:
              taxReturn.k1_distribution_status === 'not_applicable'
                ? 'default'
                : 'pointer',
          }}
        >
          <Pill intent={statusInfo.intent} label={statusInfo.label} />
        </div>
      </Tooltip.Trigger>
    </Tooltip>
  );
};
